module.exports = __webpack_public_path__ + "img/wait.2f00f03b.png";